import axios from "axios";

const fusionSolarApi = axios.create({
  baseURL: `${process.env.REACT_APP_API_URL}api/fusionSolar/`,
  transformResponse: [
    ...(axios.defaults.transformResponse as any),
    (data: any) => {
      const parsed = typeof data === "string" ? JSON.parse(data) : data;
      if (parsed?.failCode === 305) {
        const error = new Error(parsed.message || "USER_MUST_RELOGIN");
        (error as any).failCode = 305;
        throw error;
      }
      return parsed;
    },
  ],
});

// 🧠 Token caching (żeby nie odpalać wielu loginów naraz)
let tokenPromise: Promise<string> | null = null;

// 🔑 Funkcja pobierająca token (z cache lub z logowania)
const getToken = async (): Promise<string> => {
  const cached = localStorage.getItem("huaweiToken");
  if (cached && cached !== "null") {
    return cached;
  }

  // Jeśli już trwa logowanie – poczekaj
  if (tokenPromise) {
    return tokenPromise;
  }

  tokenPromise = axios
    .get(`${process.env.REACT_APP_API_URL}api/fusionSolar/login`)
    .then((res) => {
      const token = res.data.token;
      if (!token) throw new Error("Brak tokena po logowaniu");
      localStorage.setItem("huaweiToken", token);
      return token;
    })
    .finally(() => {
      tokenPromise = null; // Resetuj po zakończeniu
    });

  return tokenPromise;
};

// ✅ Interceptor request — dołącza token jako cookie
fusionSolarApi.interceptors.request.use(async (config) => {
  const token = await getToken();
  config.params = {
    ...(config.params || {}),
    cookie: token,
  };
  return config;
});

// ✅ Interceptor response — obsługuje failCode 305 (USER_MUST_RELOGIN)
// ✅ response interceptor — zadziała teraz na 305
fusionSolarApi.interceptors.response.use(
  (res) => res,
  async (error) => {
    const failCode = (error as any)?.failCode;

    if (failCode === 305) {
      console.warn("🔁 Token Huawei wygasł — ponowne logowanie...");

      try {
        const res = await axios.get(`${process.env.REACT_APP_API_URL}api/fusionSolar/login`);
        const newToken = res.data.token;
        if (!newToken) throw new Error("Nie udało się odświeżyć tokena");

        localStorage.setItem("huaweiToken", newToken);

        // ✅ Bezpiecznie nadpisujemy params
        error.config.params = {
          ...(error.config.params || {}),
          cookie: newToken,
        };

        return fusionSolarApi.request(error.config);
      } catch (retryError) {
        console.error("❌ Błąd przy ponownym logowaniu:", retryError);
        return Promise.reject(retryError);
      }
    }

    return Promise.reject(error);
  }
);



export default fusionSolarApi;
